module.exports = __webpack_public_path__ + "static/media/project-sway.f7a5b2ec.jpg";